<template>
  <section class="register-footer">
    <!-- <Messages></Messages>-->
    <p class="text-footer">
      {{ $t("register.messageFooter1")}}
      <strong v-if="region !=='mena'">Tradeview {{ cabinetOrigin }}</strong>
      <strong v-if="region ==='mena'">Tradeview Financial Markets SAC</strong>
      {{ $t("register.messageFooter2") }}
      <a
        href="https://www.tradeview.eu/pricing"
        target="_blank"
        style="font-weight: 100; color: #b2b2b2; text-decoration: underline"
        >link.
      </a>
      <span class="dir"
        ><strong>{{ $t("loginPage.adressOficce") }}</strong> Floor 6, Suite 3,
        Airways House, High Street, Sliema SLM1549, Malta. | +356 203 11017 |
        <a href="mailto:techsupport@tvmarkets.com" class="underline"
          >techsupport@tvmarkets.com</a
        ></span
      >
      |
      <a :href="bucket + 'Terms+and+Conditions.pdf'" target="_blank">{{
        $t("loginPage.termsAndConditions")
      }}</a>
      |
      <a :href="bucket + 'Privacy+Policy.pdf'" target="_blank">{{
        $t("loginPage.privacyPolicy")
      }}</a>
      |
      <a :href="bucket + 'AML+Policy.pdf'" target="_blank">{{
        $t("loginPage.amlPolicy")
      }}</a>
      |
      <a :href="bucket + 'Refund+Policy.pdf'" target="_blank">{{
        $t("loginPage.refundPolicy")
      }}</a>
      |
      <a :href="bucket + 'Risk+Disclosure.pdf'" target="_blank">{{
        $t("loginPage.riskDisclosure")
      }}</a>
      |
      <a :href="bucket + 'Complaints+Procedure.pdf'" target="_blank">{{
        $t("loginPage.complaintsProcedure")
      }}</a>
      |
      <a :href="bucket + 'Cookie+Policy.pdf'" target="_blank">{{
        $t("loginPage.cookiePolicy")
      }}</a>
    </p>
  </section>
  <section class="register-footer mobile">
    <p class="text-footer">
      <span class="dir"
        ><strong>Tradeview{{ cabinetOrigin }} Ltd. Office:</strong> Floor 6,
        Suite 3, Airways House, High Street, Sliema SLM1549, Malta. | +356 203
        11017 |
        <a href="mailto:techsupport@tvmarkets.com" class="underline"
          >techsupport@tvmarkets.com</a
        ></span
      >
    </p>
  </section>
</template>

<script>
import { ref } from "vue";
import Messages from "@/components/Messages";
import original from "@/store/original";

export default {
  name: "Footer",
  components: {
    Messages,
  },
  setup() {
    const bucket = ref(original.state.buckets.uk);
    const cabinetOrigin = ref(process.env.VUE_APP_CABINET_ORIGIN.toUpperCase());

    return {
      original,
      bucket,
      cabinetOrigin,
    };
  },
};
</script>


<style scoped>
</style>